export default __webpack_public_path__ + "static/3-f337e730e77bb05b92f81ad61483e77b.jpg";